import ReactGA from 'react-ga';
import Header from './components/common-header/Header';
import Footer from './components/common-footer/Footer';
import './assets/sass/App.scss';
import heroImg from './assets/img/hero.png';
import doctorImg from './assets/img/dr-gulay-serhatkulu.png';
import image1 from './assets/img/img1.png';
import image2 from './assets/img/img2.png';
import image3 from './assets/img/img3.png';
import basfImg from './assets/img/basf.png';
import { useEffect, useState } from 'react';
ReactGA.initialize('UA-79459204-74');
ReactGA.pageview(window.location.pathname + window.location.search);

function App() {
  const [scroll, setScroll] = useState(false);
  const sendEvent = (url) => {
    ReactGA.event({
      category: 'User',
      action: `clicked on ${url}`
    });
    // window.open(url);
  };
  useEffect(() => {
    document.onscroll = () => {
      if (!scroll) {
        ReactGA.event({
          category: 'User',
          action: `Scrolled`
        });
        setScroll(true);
      }
    };
  }, [scroll]);
  return (
    <div>
      <Header clientName={'BASF'} />
      <section className="hero-section">
        <div className="hero-title">
          <h1>Closing the Loop on a Sustainable Future</h1>
          <h2>Solutions for a sustainable future require new ways of thinking.</h2>
        </div>
        <div style={{ backgroundImage: heroImg }} className="hero"></div>
      </section>
      <section>
        <p>
          The value of many plastics products is easily seen in their use in our everyday lives, but
          what is not so apparent is the value of these products throughout their life cycle.
          Thoughtful management of the entire lifecycle can highlight additional contributions to
          the circular economy. To get the maximum value from these materials, we must consider what
          they are, what they do, and how they might best participate in the circular economy.
        </p>
        <p>
          Why does this matter? To achieve any impactful change in our daily lifestyles, we need to
          consider every link in the value chain. This can include how the plastics are made—from
          altering their properties to serve a practical and energy-efficient purpose—to revisiting
          the infrastructure of how we recover value from what was previously perceived as waste.
          This is where BASF—and partners in the value chain—are working together to create a new
          economy and change the way we think about plastics.
        </p>
      </section>

      <section>
        <h3>The Mission to Find Solutions</h3>
        <p>
          Perhaps no one understands the complexities of the plastics journey more than Dr. Gulay
          Serhatkulu, Senior Vice President of BASF’s Performance Materials business in North
          America. Her team is dedicated to solving the big problems and inventing new solutions as
          it relates to high-performance engineering plastics and foams. These products support
          major industries such as transportation, construction, industrial applications, and
          consumer goods. And after speaking with Dr. Serhatkulu, you realize this is someone who
          has used her education, experience, and leadership to develop solutions that support a
          circular economy.
        </p>
        <p>
          That does not mean, however, that Dr. Serhatkulu does not see the human side of this
          issue.
        </p>
        <p>
          “The plastic topic is very emotional because of the tragic pictures you see of animals and
          a whole mountain of trash,” she says. “But I realize that to leave the next generation a
          more sustainable world, we need to focus on finding solutions.”
        </p>
      </section>

      <section className="cta-section">
        <div className="cta">
          <img
            alt="Dr Gulay Serhatkulu's Profile for Desktop"
            src={doctorImg}
            className="cta__profile-image"
          />
          <div className="cta__inner">
            <p className="cta__headliner">
              There are many ways to make a difference in the supply chain by examining the
              environmental impact of the entire lifecycle of the product.”
            </p>
            <div className="cta__profile-info">
              <img alt="Dr Gulay Serhatkulu's Profile" src={doctorImg} />
              <div>
                <p className="title">Dr. Gulay Serhatkulu</p>
                <p>
                  Senior Vice President of BASF’s Performance Materials business in North America.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section>
        <h3>Inside the Value Chain</h3>
        <p>
          Delving into this world can be heady. But in order to contribute to the conversation and
          provide real solutions, we need to understand the science and engineering of both
          recovering and creating the next generation of plastic materials. These plastics must be
          lighter, tougher, and produced more sustainably throughout the value chain. Often there
          are separate organizations involved in each step, including everything from design,
          manufacturing, processing, shipping, delivery and the ultimate disposal or recovery of the
          product.
        </p>
        <p>
          On a global level, BASF has made a joint commitment to process at least 160,000 tons of
          recycled plastic by 2025. To achieve this target, they plan on using up to 250,000 tons of
          raw material from waste with the goal of being CO₂ neutral in the production of their
          products, including plastics, by 2050.
        </p>
      </section>

      <section className="cta-section">
        <div className="cta cta--text-only">
          <div className="cta__inner">
            <p className="cta__headliner">
              We as consumers [make] the right choices but we have infrastructure challenges with
              the availability of proper recycling systems. We have to work on radically increasing
              the economics, quality, and uptake of recycling.”
            </p>
            <div className="cta__profile-info">
              <div>
                <p className="title">Dr. Gulay Serhatkulu</p>
                <p>
                  Senior Vice President of BASF’s Performance Materials business in North America.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section>
        <h3>The Challenge of Closing the Loop</h3>
        <p>
          As individuals, we are responsible for the waste we produce. But in some cases, our
          efforts to recycle that waste are not adding value to a sustainable future. According to
          Dr. Serhatkulu, “We as consumers [make] the right choices but we have infrastructure
          challenges with the availability of proper recycling systems. We have to work on radically
          increasing the economics, quality, and uptake of recycling.” She adds that everything from
          individual purchasing decisions to social values to corporate strategies are what will
          drive the change we want to see in the world.
        </p>
        <p>
          On the topic of corporate strategies, Dr. Serhatkulu says that “there are many ways to
          make a difference in the supply chain by examining the environmental impact of the entire
          lifecycle of the product.” It’s for this reason that BASF is focusing on the unmet needs
          of its customers. For example, they can increase the durability of products, so they last
          longer thus reducing consumption. Or the performance of the product itself can provide a
          benefit during its use, such as in the case of insulation in homes to reduce energy
          consumption.
        </p>
      </section>

      <section>
        <h3>Trusting the Process</h3>
        <p>
          BASF looks for new products and processes that reduce energy demand and global warming
          potential as well as developing products that reduce waste and use fewer resources. One
          example is called{' '}
          <a
            href="https://www.basf.com/us/en/who-we-are/sustainability/we-drive-sustainable-solutions/circular-economy/mass-balance-approach/chemcycling.html"
            className="link-url"
            target="_blank"
            rel="sponsored"
            onClick={() => {
              sendEvent(
                'https://www.basf.com/us/en/who-we-are/sustainability/we-drive-sustainable-solutions/circular-economy/mass-balance-approach/chemcycling.html'
              );
            }}
          >
            ChemCycling™
          </a>{' '}
          which is a type of chemical recycling where high temperatures are used to break down
          plastic waste in the absence of oxygen to create pyrolysis oil. It can then be used by
          BASF to make other products such as{' '}
          <a
            href="https://www.basf.com/global/en/media/news-releases/2021/03/p-21-161.html"
            className="link-url"
            target="_blank"
            rel="sponsored"
            onClick={() => {
              sendEvent('https://www.basf.com/global/en/media/news-releases/2021/03/p-21-161.html');
            }}
          >
            packaging
          </a>{' '}
          and
          <a
            href="https://www.basf.com/global/en/who-we-are/sustainability/whats-new/sustainability-news/2021/outdoor-pants-made-of-old-tires.html"
            className="link-url"
            target="_blank"
            rel="sponsored"
            onClick={() => {
              sendEvent(
                'https://www.basf.com/global/en/who-we-are/sustainability/whats-new/sustainability-news/2021/outdoor-pants-made-of-old-tires.html'
              );
            }}
          >
            {' '}
            performance gear
          </a>
          . The share of recycled raw material is allocated to the products through the mass balance
          approach, a technique used extensively in the agriculture and renewable fuels industries.
          Although the technology is in its infancy, it allows for recovery of some materials which
          cannot otherwise be recycled using current recycling methods. Due to this unique value,
          the industry has the confidence to invest in it.
        </p>
      </section>

      <section className="photo-grid-section">
        <div className="photo-grid">
          <div>
            <img alt="Scientist examining a plastic sheet sample" src={image1} />
          </div>
          <div className="smaller-images">
            <img alt="Two Engineers Adjusting Equipment" src={image2} />
            <img alt="Two Engineers Checking Equipment" src={image3} />
          </div>
        </div>
        <div className="photo-grid-caption">
          In BASF’s ChemCycling™ project, plastic waste is transformed into pyrolysis oil using a
          thermochemical process. The oil can be fed in the BASF Verbund, replacing fossil
          resources.
        </div>
      </section>

      <section>
        <p>
          Another innovative solution is a 100% recyclable bicycle tube. Bicycle tubes are
          constructed of high-performance materials which cannot be readily recycled in existing
          recycling programs. This new tube is made of{' '}
          <a
            href="https://www.basf.com/global/en/media/news-releases/2020/10/p-20-309.html"
            target="_blank"
            rel="sponsored"
            className="link-url"
            onClick={() => {
              sendEvent('https://www.basf.com/global/en/media/news-releases/2020/10/p-20-309.html');
            }}
          >
            Elastollan®
          </a>
          , a thermoplastic polyurethane material. It’s tougher than other bicycle tubes and also
          resists oil and grease from street riding. Plus, it’s 40% lighter, which improves handling
          and is puncture resistant. How do you recycle it? Customers can simply return the tube to
          the seller where it is then reprocessed into new products. This engineered technology can
          be used in other applications, such as footwear.
        </p>
        <p>
          BASF is also working on more environmentally conscious{' '}
          <a
            href="https://plastics-rubber.basf.com/global/en/performance_polymers/news-events/stories/how-sustainability-drives-innovative-furniture-desgin.html"
            className="link-url"
            target="_blank"
            rel="sponsored"
            onClick={() => {
              sendEvent(
                'https://plastics-rubber.basf.com/global/en/performance_polymers/news-events/stories/how-sustainability-drives-innovative-furniture-desgin.html'
              );
            }}
          >
            furniture
          </a>
          , certified{' '}
          <a
            href="https://plastics-rubber.basf.com/global/en/performance_polymers/products/ecovio.html"
            className="link-url"
            target="_blank"
            rel="sponsored"
            onClick={() => {
              sendEvent(
                'https://plastics-rubber.basf.com/global/en/performance_polymers/products/ecovio.html'
              );
            }}
          >
            compostable biopolymers
          </a>{' '}
          that help reduce greenhouse gas emissions by enabling the diversion of food scraps from
          landfills, and more sustainable car parts, too. Remember that third row you wanted in your
          family station wagon? BASF is working with commercial automotive brands to make that 3rd
          row lighter so you get better gas mileage by replacing metal with a sophisticated plastic
          composite solution with the same performance. It’s another way to reduce fuel consumption
          and cost for the consumer.
        </p>
        <p>
          “We cannot solve the existing and growing plastics problem with one single approach,” says
          Dr. Serhatkulu. “We have to think of different solutions to create a smart, circular
          plastics economy.”
        </p>
        <p className="link-to">
          To learn more about BASF’s plastics journey, click{' '}
          <a
            className="link-to-link"
            href="https://plasticsjourney.basf.com/plastic/en/"
            target="_blank"
            rel="sponsored"
            onClick={() => {
              sendEvent('https://plasticsjourney.basf.com/plastic/en/');
            }}
          >
            here
          </a>
          .
        </p>
        <p className="link-to">
          <a
            href="https://www.basf.com/us/en.html"
            target="_blank"
            rel="sponsored noopener"
            onClick={() => {
              sendEvent('https://www.basf.com/us/en.html');
            }}
          >
            {' '}
            <img alt="BASF Logo" className="basf-logo" src={basfImg} />
          </a>
        </p>
      </section>
      <Footer />
    </div>
  );
}

export default App;
